// @flow
import React, { PureComponent, Fragment } from 'react';

import TextInputMaterial from 'components/fragments/input/material/TextInputMaterial';
import CheckboxInput from 'components/fragments/input/CheckboxInput';
import Loading from 'components/fragments/Loading';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';

import { validateEmail } from 'utils/validatorUtils';
import { getFileNameFromPath } from 'utils/urlUtils';
import { dynamicClassName } from 'utils/dynamicClassName';
import { STATUS_LOADING, STATUS_SUCCESS, STATUS_FAILURE } from 'constants/statusConstants';

import type { ContactFormType } from 'types/ContactForm';
import type { Status } from 'types/Status';
import type { BlocContent } from 'types/NewsletterBloc';

export type StateProps = {
  contactForm: Array<ContactFormType>,
  sendStatus: Status,
  fetchStatus: Status
};

export type DispatchProps = {
  postContactForm: (formInputs: Object, id: number) => void,
  displayModal: (modalObject: string, content: Object, force: boolean) => void,
  fetchContactForm: () => void
};

type Props = {
  location: any,
  history: any,
  message?: string,
  content?: Array<BlocContent>
} & StateProps &
  DispatchProps;

type State = {
  prenom: string | null,
  nom: string | null,
  email: string | null,
  region: string | null,
  file: string,
  consent1: boolean,
  consent2: boolean,
  consent3: boolean,
  message: string,
  showFileError: boolean,
  fileError: string | null,
  formSent: boolean,
  error: string
};

class ContactFormGrandSoutien extends PureComponent<Props, State> {
  props: Props;
  state: State = {
    prenom: null,
    nom: null,
    email: null,
    region: null,
    file: '',
    consent1: false,
    consent2: false,
    consent3: false,
    message: '',
    showFileError: false,
    fileError: '',
    error: '',
    formSent: false
  };

  componentDidMount = () => {
    const { fetchContactForm } = this.props;
    fetchContactForm();
  };

  _handleChange = (name: string, value: any) => {
    this.setState({ [name]: value });
  };

  setFile = (e: any) => {
    const file = e.target.value;
    this.setState({ file });
  };

  setMessage = (e: any) => {
    const message = e.target.value;
    this.setState({ message });
  };

  isFormValid = () => {
    const { prenom, nom, email, region, consent3, consent2 } = this.state;

    if (
      !this.isFileValid() ||
      prenom === null ||
      prenom === '' ||
      nom === null ||
      nom === '' ||
      email === null ||
      !validateEmail(email) ||
      region === null ||
      region === '' ||
      !consent3 ||
      !consent2
    ) {
      return false;
    }

    return true;
  };

  isFileValid = () => {
    // eslint-disable-next-line
    const input: any = document.querySelector('input[type="file"]');
    if (input) {
      const documentData = input.files[0];
      if (!documentData) {
        this.setState({ fileError: `Une video ou une image est obligatoire`, showFileError: true });
      } else if (documentData.size > 40000000) {
        this.setState({ fileError: `La taille maximale autorisée est 40 Mo`, showFileError: true });
      } else if (
        documentData.type !== 'video/mp4' &&
        documentData.type !== 'video/quicktime' &&
        documentData.type !== 'image/jpg' &&
        documentData.type !== 'image/png'
      ) {
        this.setState({
          fileError: `Les formats autorisés sont : video au format mov et mp4 ou images au format jpg ou png`,
          showFileError: true
        });
      } else {
        this.setState({ fileError: '', showFileError: false });
      }
      return (
        documentData &&
        documentData.size < 40000000 &&
        (documentData.type === 'video/mp4' ||
          documentData.type === 'video/quicktime' ||
          documentData.type === 'image/jpg' ||
          documentData.type === 'image/png')
      );
    } else {
      this.setState({ fileError: `Une video ou une image est obligatoire`, showFileError: true });
      return false;
    }
  };

  handleSubmit = (e: MouseEvent) => {
    e.preventDefault();
    const { postContactForm, displayModal } = this.props;
    const { prenom, nom, email, region, consent1, consent2, consent3 } = this.state;

    this.setState({ error: '' });

    if (!consent2) {
      displayModal(
        'MODAL_NEWSLETTER_MISSING_OPT',
        {
          text: `Pour participer au grand soutien, merci d'accepter les conditions de la Fédération Française de Rugby`
        },
        true
      );
    } else if (!consent3) {
      displayModal(
        'MODAL_NEWSLETTER_MISSING_OPT',
        {
          text: `Pour participer au grand soutien, merci d'autoriser la Fédération Française de Rugby
          à réutiliser votre contenu`
        },
        true
      );
    } else {
      if (this.isFormValid()) {
        const input: any = document.querySelector('input[type="file"]');
        var documentData: HTMLInputElement = input.files[0];

        const formId = this._getFormId();

        const formData = {
          'grand-soutien-prenom': prenom ? prenom : '',
          'grand-soutien-nom': nom ? nom : '',
          'grand-soutien-email': email ? email : '',
          'grand-soutien-region': region ? region : '',
          'grand-soutien-consent1': consent1 ? consent1 : false,
          'grand-soutien-consent2': consent2 ? consent2 : false,
          'grand-soutien-consent3': consent3 ? consent3 : false,
          'grand-soutien-video': documentData,
          _wpcf7_unit_tag: formId
        };
        this.setState({ formSent: true });
        postContactForm(formData, formId);
      } else {
        this.setState({
          error: 'Veuillez vérifier le contenu du formulaire',
          prenom: prenom === null ? '' : prenom,
          nom: nom === null ? '' : nom,
          email: email === null ? '' : email,
          region: region === null ? '' : region
        });
      }
    }
  };

  _getFormId = () => {
    const { contactForm } = this.props;

    if (contactForm && contactForm.length > 0) {
      const grandSoutienForm = contactForm.filter(form => form.title === 'grand-soutien');

      if (grandSoutienForm && grandSoutienForm.length > 0) {
        return grandSoutienForm[0].id;
      }
    }

    return 0;
  };

  _renderBlocContent = () => {
    const { content } = this.props;
    if (!content) return null;
    return content.map<any>((blocFigure, index) => {
      return <ContentBloc key={index} {...blocFigure} />;
    });
  };

  render() {
    const { fetchStatus, sendStatus, message, content } = this.props;

    const { prenom, nom, email, region, error, showFileError, fileError, formSent } = this.state;

    const labels = {
      optin1: `J’autorise la FFR à transmettre certaines de mes données personnelles 
      (nom, prénom, e-mail) à des tiers, et notamment ses partenaires et fournisseurs officiels, 
      à des fins commerciales, associatives ou humanitaires.`,
      optin2: `J’accepte les 
      <a href="/cgu" target="_blank" rel="nofollow noreferer">conditions générales d’utilisation du site</a>. *`,
      optin3: `Je certifie disposer des droits nécessaires pour partager et publier ce contenu, 
      j’accepte que la FFR relaie ces contenus sur ses réseaux sociaux. *`
    };

    if (
      fetchStatus !== STATUS_SUCCESS ||
      (sendStatus !== STATUS_SUCCESS && sendStatus !== STATUS_FAILURE && formSent)
    ) {
      return <Loading isWhite />;
    }

    if (sendStatus === STATUS_SUCCESS && fetchStatus === STATUS_SUCCESS) {
      return (
        <div className="mb-5 modal-content" style={{ boxShadow: 'none', textAlign: 'center' }}>
          <h3 className="mb-4">Merci de ne faire XV avec notre équipe de de France ! </h3>
          <div className="modal__body modal__body--medium narrow-2">
            <div className="circle-icon circle-icon--check"></div>
            <span>Nous leur partagerons votre message dès que possible !</span>
          </div>
        </div>
      );
    }

    const classNamesSend = dynamicClassName('btn btn--primary js-contact-send');
    sendStatus === STATUS_LOADING && classNamesSend.add('is-disabled');

    if (!this._getFormId()) {
      return (
        <div className="mb-5 modal-content" style={{ boxShadow: 'none', textAlign: 'center' }}>
          <div className="modal__body modal__body--medium narrow-2">
            <div className="circle-icon circle-icon--alert"></div>
            <span>{`Il n'y a pas de jeu concours actuellement en ligne.`}</span>
          </div>
        </div>
      );
    }

    return (
      <form action="#">
        {message && <p className="mb-5">{message}</p>}
        <div className="form-row">
          <TextInputMaterial
            id="prenom"
            label="Votre prénom *"
            errorMessage="Ce champ est requis"
            hasError={prenom !== null && prenom.length === 0}
            onChange={(value: string) => this._handleChange('prenom', value)}
          />
          <TextInputMaterial
            id="nom"
            label="Votre nom *"
            errorMessage="Ce champ est requis"
            hasError={nom !== null && nom.length === 0}
            onChange={(value: string) => this._handleChange('nom', value)}
          />
        </div>
        <TextInputMaterial
          id="email"
          label="Adresse mail *"
          errorMessage={email === '' ? 'Ce champ est requis' : "Cet e-mail n'est pas valide"}
          hasError={email !== null && !validateEmail(email)}
          onChange={(value: string) => this._handleChange('email', value)}
        />
        <TextInputMaterial
          id="region"
          isLight
          label="Region *"
          errorMessage="Ce champ est requis"
          hasError={region !== null && region.length === 0}
          onChange={(value: string) => this._handleChange('region', value)}
        />
        <div className="mb-3">
          <div
            className={
              showFileError
                ? 'box box--smoke input--file form-contact__file has-error'
                : 'box box--smoke input--file form-contact__file'
            }
          >
            <label htmlFor="file" style={{ display: 'block' }}>
              {this.state.file ? (
                <Fragment>
                  <i className="icon icon-pj" /> <span>{getFileNameFromPath(this.state.file)}</span>
                </Fragment>
              ) : (
                <Fragment>
                  <i className="icon icon-pj" /> <span>Sélectionner une video ou une image</span>{' '}
                  <small>(40 Mo max.)</small> *
                </Fragment>
              )}
            </label>
            <input
              id="file"
              name="inputFile"
              type="file"
              onChange={this.setFile}
              accept="video/mp4, video/quicktime, image/jpg, image/png"
            />
          </div>
          {showFileError && fileError && <span className="input__error">{fileError}</span>}
        </div>
        <CheckboxInput
          className={'checkbox'}
          id="optin3"
          label={labels['optin3']}
          onChange={value => this._handleChange('consent3', value)}
        />
        <CheckboxInput
          className={'checkbox'}
          id="optin2"
          label={labels['optin2']}
          onChange={value => this._handleChange('consent2', value)}
        />
        <CheckboxInput
          className={'checkbox'}
          id="optin1"
          label={labels['optin1']}
          onChange={value => this._handleChange('consent1', value)}
        />
        <div className="form-action">
          <div>
            {error ? (
              <p>
                <span>{error}</span>
              </p>
            ) : (
              sendStatus === STATUS_SUCCESS && (
                <p>
                  <span style={{ color: '#4CB848', fontSize: '18px' }}>Votre participation a bien été envoyée</span>
                </p>
              )
            )}
            <p className="ft-tertiary">* champs obligatoires</p>
          </div>
          <div>
            <button className="btn btn--primary js-contact-send" type="button" onClick={this.handleSubmit}>
              Participer
            </button>
          </div>
        </div>
        {content && <div className="mb-5">{this._renderBlocContent()}</div>}
      </form>
    );
  }
}

export default ContactFormGrandSoutien;
